import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Table,
  Row,
  Col,
  TreeSelect,
  DatePicker,
  Spin,
  Badge,
  Select,
} from "antd";
import { Link } from "react-router-dom";
import Button from "antd-button-color"; //npm install antd-button-color  || https://www.npmjs.com/package/antd-button-color
import { errorHandle, openNotificationWithIcon } from "../../../Function";
// import "./ViewQuestion.css";
// import ModalCreateGroup from "./ModalGroup/ModalCreateGroup";
// import ModalCreateQuiz from "./ModalQuiz/ModalCreateQuiz";
import { DownloadOutlined } from "@ant-design/icons";
import moment from "moment";
import { getListSetExamAPI } from "api/ismsApi";
import { getResultExamAPI, postDownloadResultExamApi } from "api/getResultExam";
import { GetTypeQuestionApi } from "api/getQuiz";
// import EditUserGroup from "./ModalUserGroup/EditUserGroup";
import "./ViewResultExam.css";
import fnFileDownload from "js-file-download";

function disabledMonth(current) {
  // Can not select days after today and today
  const currentDate = new Date();
  return (
    current &&
    current >
      moment(
        new Date(currentDate.getFullYear(), currentDate.getMonth()),
        0
      ).endOf("day")
  );
}

const getColumns = ({ pager, selectedGroup, arrTypeQuestion }) => [
  {
    title: "STT",
    dataIndex: "index",
    key: "index",
    align: "center",
    render: (value, item, index) =>
      ((pager.current || 1) - 1) * pager.pageSize + index + 1,
    // sortDirections: ["descend", "ascend", "descend"],
    // ellipsis: true,
    width: 50,
    type: "text",
    // fixed: "left",
  },
  {
    title: "Nhân viên",
    dataIndex: "username",
    key: "username",
    filterKey: "username",
    type: "text",
    width: 150,
    render: (text, record) => record.msnv + "-" + text,
  },
  {
    title: "Bộ phận",
    dataIndex: "fore_team__bophan__tenBophan",
    className: "highlight",
    key: "fore_team__bophan__tenBophan",
    filterKey: "fore_team__bophan__tenBophan",
    type: "text",
    width: 100,
  },
  {
    title: "Team",
    dataIndex: "fore_team__tenTeam",
    className: "highlight",
    key: "fore_team__tenTeam",
    filterKey: "fore_team__tenTeam",
    type: "text",
    width: 100,
  },
  {
    title: "Chức vụ",
    dataIndex: "fore_chucvu__ten_cv",
    className: "highlight",
    key: "fore_chucvu__ten_cv",
    filterKey: "fore_chucvu__ten_cv",
    type: "text",
    width: 120,
  },
  {
    title: "Ngày thi",
    dataIndex: "data_user_exam",
    className: "highlight",
    key: "data_user_exam",
    filterKey: "data_user_exam",
    type: "text",
    align: "center",
    width: 150,
    render: (item, record) =>
      item.length !== 0 && item[0].ngay_thi && item[0].ngay_thi.split(" ")[0],
  },
  {
    title: "Đợt thi",
    dataIndex: "data_user_exam",
    className: "highlight",
    key: "data_user_exam",
    filterKey: "data_user_exam",
    type: "text",
    render: (item, record) => item.length !== 0 && item[0].ma_de_thi,
  },
  {
    title: "Nhóm thi",
    dataIndex: "data_user_exam",
    key: "data_user_exam",
    filterKey: "data_user_exam",
    type: "text",
    render: (item, record) =>
      item.length !== 0
        ? item[0].data_group[0].note
        : arrTypeQuestion.find((x) => x.id === selectedGroup)?.note,
  },

  {
    title: "Thi lại / Tổng được thi",
    dataIndex: "data_user_exam",
    className: "highlight",
    key: "data_user_exam",
    filterKey: "data_user_exam",
    align: "center",
    type: "text",
    render: (item, record) =>
      item.length !== 0 &&
      `${item[0].so_lan_thi_lai ?? 0} / ${item[0].so_lan_duoc_thi ?? 0}`,
  },
  {
    title: "Kết quả",
    dataIndex: "data_user_exam",
    className: "highlight",
    key: "data_user_exam",
    filterKey: "data_user_exam",
    align: "center",
    type: "text",
    render: (item, record) => {
      if (item.length === 0) {
        return <span></span>;
      }
      if (item[0].ket_qua === null || item[0].ket_qua === undefined) {
        return <span style={{ color: "gray" }}>Không tham gia</span>;
      }
      if (item[0].ket_qua === true) {
        return <span style={{ color: "green" }}>Đạt</span>;
      }
      if (item[0].ket_qua === false) {
        return <span style={{ color: "red" }}>Không đạt</span>;
      }

      return <span style={{ color: "green" }}>Lỗi dữ liệu</span>;
    },
  },
  {
    title: "Số câu đúng",
    dataIndex: "data_user_exam",
    className: "highlight",
    key: "data_user_exam",
    filterKey: "data_user_exam",
    align: "center",
    type: "text",
    render: (item, record) => item.length !== 0 && item[0].diem_thi,
  },
  {
    title: "Điểm thi",
    dataIndex: "data_user_exam",
    className: "highlight",
    key: "data_user_exam",
    filterKey: "data_user_exam",
    align: "center",
    type: "text",
    render: (item, record) => item.length !== 0 && item[0].diem_thi_quy_doi,
  },

  // {
  //   title: "Thao tác",
  //   dataIndex: "",
  //   className: "highlight",
  //   key: "",
  //   filterKey: "",
  //   type: "text",
  //   align: "center",
  //   width: 100,
  //   render: (text, record) =>
  //     getBtnAction({
  //       record
  //     }),
  //   canSearch: true,
  // },
];

const ViewExam = () => {
  const defaultPageSize = 10;
  const [pager, setPager] = useState({
    pageSize: defaultPageSize,
    count: 0,
    current: 1,
  });
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loading_page, setLoading_page] = useState(false);
  const [lsExam, setLsExam] = useState([]);
  const [currentExam, setCurrentExam] = useState([]);
  const [treeDataExam, setTreeDataExam] = useState([]);
  // const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [loadingExam, setLoadingExam] = useState(false);
  // const [lsTeam, setLsTeam] = useState([]);
  // const [currentTeam, setCurrentTeam] = useState([]);
  // const [treeData, setTreeData] = useState([]);
  // const [isShowExport, setIsShowExport] = useState(false);
  const [currentSelectedDate, setCurrentSelectedDate] = useState(
    moment(new Date())
  );
  const [arrTypeQuestion, setArrTypeQuestion] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);

  const userInfo = useSelector((state) => state.getUserInfo.userInfo);

  const fetchDataExam = (params = {}) => {
    setLoadingExam(true);
    getListSetExamAPI(params)
      .then((res) => {
        setLsExam(res.data.results);
        setLoadingExam(false);
      })
      .catch((err) => {
        errorHandle(err);
        setLoadingExam(false);
      });
  };

  const fetchDataUserExam = (params = {}) => {
    setLoading(true);
    getResultExamAPI(params)
      .then((res) => {
        setData(res.data.results);
        setLoading(false);
      })
      .catch((err) => {
        errorHandle(err);
        setLoading(false);
      });
  };

  const fetchTypeQs = (params = {}) => {
    setLoading(true);
    GetTypeQuestionApi(params)
      .then((res) => {
        setArrTypeQuestion(res.data.results);
        setSelectedGroup(res.data.results[0]["id"]);
        // Ds các đợt thi có trong nhóm và tháng/năm (ngày bắt đầu của đợt thi)
        fetchDataExam({
          month_year: moment(currentSelectedDate).format("MM/YYYY"),
          loai_cau_hoi: res.data.results[0]["id"],
        });

        setLoading(false);
      })
      .catch((err) => {
        errorHandle(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (currentSelectedDate) {
      setData([]);
      setLsExam([]);
      setCurrentExam([]);
      fetchTypeQs();
    }
  }, [currentSelectedDate]);

  const onChangeMonth = (date) => {
    setCurrentSelectedDate(date);
  };

  const onChangeGroup = (value) => {
    setSelectedGroup(value);
    setData([]);
    setLsExam([]);
    setCurrentExam([]);
    // Ds các đợt thi có trong nhóm và tháng/năm (ngày bắt đầu của đợt thi)
    fetchDataExam({
      month_year: moment(currentSelectedDate).format("MM/YYYY"),
      loai_cau_hoi: value,
    });
  };

  const onChangeExam = (value) => {
    if (value.length > 0) {
      setCurrentExam(value);
    } else {
      setCurrentExam([]);
    }
    // setCurrentExam([value]);
  };

  const tPropsConfig_Exam = {
    treeData: [
      {
        title:
          currentExam.length > 0 ? (
            <span
              onClick={() => {
                if (!loadingExam) {
                  onChangeExam([]);
                }
              }}
              className="style_SelectTeam"
            >
              Bỏ chọn tất cả
            </span>
          ) : (
            <span
              onClick={() => {
                if (!loadingExam) {
                  onChangeExam(lsExam && lsExam.map((item) => item.ma_de_thi));
                }
              }}
              className="style_SelectTeam"
            >
              Chọn tất cả
            </span>
          ),
        value: "xxx",
        disableCheckbox: true,
        disabled: true,
        className: "style_treeTeam",
      },
      ...treeDataExam,
    ],
    value: treeDataExam.length > 0 ? currentExam : undefined,
    onChange: onChangeExam,
    treeCheckable: true,
    maxTagCount: 1,
    placeholder: "Chọn đợt thi",
    style: { width: "fit-content", minWidth: 200 },
    disabled: loadingExam,
  };

  useEffect(() => {
    const treeDataExam = lsExam.map((item) => {
      return {
        title: item.ma_de_thi,
        value: item.ma_de_thi,
        key: item.ma_de_thi,
      };
    });
    setTreeDataExam(treeDataExam);

    if (lsExam?.length && currentExam.length === 0) {
      setCurrentExam([lsExam.map((item) => item.ma_de_thi)[0]]);
    }
  }, [lsExam]);

  // useEffect(() => {
  //   const treeDataTemp = lsTeam.map((item) => {
  //     return { title: item.team, value: item.idTeam, key: item.idTeam };
  //   });
  //   setTreeData(treeDataTemp);
  // }, [lsTeam]);

  useEffect(() => {
    setData([]);
    if (currentExam?.length) {
      fetchDataUserExam({
        str_code_exam: currentExam.join(","),
        loai_cau_hoi: selectedGroup,
        // idTeam: JSON.stringify(currentTeam),
      });
    }
  }, [currentExam]);

  const columns = getColumns({ pager, selectedGroup, arrTypeQuestion });

  // const onQuickChangeMonth = (type) => {
  //   if (loading) {
  //     return;
  //   }
  //   let monthChange;
  //   if (type === "previous") {
  //     monthChange = moment(selectedDate).subtract(1, "month");
  //   } else {
  //     monthChange = moment(selectedDate).add(1, "month");
  //   }
  //   setSelectedDate(monthChange);
  // };

  // const onChangeYear = (date) => {
  //   const year = date?.year(); // lấy năm dạng số nguyên
  //   setSelectedYear(year);
  // };

  // const onCancelExport = () => {
  //   setIsShowExport(false);
  // };

  const fileDownloadResult = () => {
    setLoading(true);

    if (currentExam.length === 1) {
      var filename = "Ket_Qua_ISMS_" + currentExam[0].toString() + ".xlsx";
    } else {
      var filename = "Ket_Qua_ISMS_.xlsx";
    }

    postDownloadResultExamApi({
      str_code_exam: currentExam.join(","),
      loai_cau_hoi: selectedGroup,
    })
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fnFileDownload(blob, filename);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        openNotificationWithIcon(
          "error",
          "Không tải được danh sách. Bạn vui lòng thử lại."
        );
        setLoading(false);
      });
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0 font-size-18">Kết quả thi</h4>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link to="#">ISMS</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="#">Đợt thi</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/isms/result-exam">Kết quả thi</Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <Row
          // gutter={[8, 8]}
          style={{ float: "left" }}
        >
          <Col>
            {/* <Button
              type="primary"
              className={"m-2 styleNtn_1"}
              onClick={() => onQuickChangeMonth("previous")}
              title="Tháng trước"
            >
              <i className={"fa fa-arrow-left"}></i>
            </Button>
            {isBeforeFirstDayOfMonth && (
              <Button
                type="primary"
                className={"m-2 styleNtn_1"}
                onClick={() => onQuickChangeMonth("next")}
                title="Tháng sau"
              >
                <i className={"fa fa-arrow-right"}></i>
              </Button>
            )}
            <DatePicker
              disabledDate={disabledMonth}
              style={{ borderRadius: 10 }}
              className={"m-2"}
              onChange={onChangeMonth}
              picker={"month"}
              value={selectedDate}
              format={"MM/YYYY"}
              allowClear={false}
              disabled={loading}
            /> */}
            {/* <DatePicker
              onChange={onChangeYear}
              picker="year"
              placeholder="Chọn năm"
              style={{ borderRadius: 10 }}
              value={selectedYear ? moment().year(selectedYear) : moment()}
              allowClear={false}
            /> */}

            <DatePicker
              disabledDate={disabledMonth}
              style={{ borderRadius: 10 }}
              // className={"m-2"}
              onChange={onChangeMonth}
              picker={"month"}
              value={currentSelectedDate}
              format={"MM/YYYY"}
              allowClear={false}
              disabled={loading}
            />

            <div className="styleBadge m-2 badge-group">
              <Badge.Ribbon
                text="Nhóm thi"
                color="gray"
                style={{ color: "red" }}
              >
                <Select onChange={onChangeGroup} value={selectedGroup}>
                  {arrTypeQuestion &&
                    arrTypeQuestion.map((item, index) => (
                      <Select.Option key={item.id} value={item.id}>
                        {item.note} ({item.loai_cau_hoi})
                      </Select.Option>
                    ))}
                </Select>
              </Badge.Ribbon>
            </div>
            <div className="styleBadge m-2">
              <Badge.Ribbon
                text="Đợt thi"
                color="gray"
                style={{ color: "red" }}
              >
                <TreeSelect {...tPropsConfig_Exam} />
              </Badge.Ribbon>
            </div>
            {/* <div className="styleBadge m-2">
              <Badge.Ribbon
                text="Bộ phận"
                color="gray"
                style={{ color: "red" }}
              >
                <TreeSelect {...tPropsConfig_BoPhan} />
              </Badge.Ribbon>
            </div>
            <div className="styleBadge">
              <Badge.Ribbon text="Team" color="gray" style={{ color: "red" }}>
                <TreeSelect {...tPropsConfig} />
              </Badge.Ribbon>
            </div> */}
          </Col>
          <Col>
            <Button
              type="success"
              className={"m-2"}
              // onClick={() => setIsShowExport(true)}
              onClick={fileDownloadResult}
              icon={<DownloadOutlined />}
            >
              Tải kết quả thi
            </Button>
          </Col>
        </Row>
      </div>
      <Spin spinning={loading_page}>
        <div className="row justify-content-center">
          {/* <div
            className="col-auto"
            // style={{ maxWidth: "1000px", overflowX: "auto" }}
          > */}
          <Table
            dataSource={data}
            columns={columns}
            loading={loading}
            className={"custom-table-hover style-6"}
            bordered={true}
            size={"small"}
            rowKey="id"
            pagination={false}
          />
          {/* </div> */}
        </div>
      </Spin>
      {/* {isShowExport && (
        <ModalExport
          open={isShowExport}
          onCancel={onCancelExport}
          lsExam={lsExam}
        />
      )} */}
    </>
  );
};

export default ViewExam;
